import { computed } from 'vue';

import { toQualificationsPatch, toStaffQualifications } from '../../infrastructure/mappers/staffQualificationsMapper';

/**
 * The qualifications on a stored person record, and the seam to that stored shape.
 *
 * IT EXISTS FOR THE LAYER RULE, not for the state, which is the same reason `useProviderIdentity`
 * exists one context over. A component may not reach `infrastructure/`; a composable is where that
 * translation is allowed to happen. Reading the record is a computed and nothing more, and the rule
 * is what decides it lives here rather than in the panel's own script.
 *
 * IT HOLDS NO DRAFT AND NO SESSION. Every list here rides the host's own record: the panel hands
 * back a patch and the host's save writes it, so there is nothing to stage, no unit of work and no
 * repository. `useProviderIdentity` keeps a draft only because a half-typed NPI is not a value the
 * domain accepts; nothing here is edited a keystroke at a time.
 *
 * THE PATCH CARRIES EVERY LIST THIS CONTEXT OWNS, always. The host merges rather than applying a
 * delta, so a list left out of a patch is a list written as EMPTY. Each one therefore either comes
 * from the caller or is carried across untouched, and adding a list to this context means adding it
 * here too.
 *
 * @param {import('vue').Ref<Object|null>} person - the stored person record the host is editing
 */
// eslint-disable-next-line import/prefer-default-export
export function useStaffQualifications(person) {
  const EMPTY = { degrees: [], credentials: [] };

  const qualifications = computed(() => toStaffQualifications(person.value) ?? EMPTY);

  const patchFor = (next) => toQualificationsPatch({
    degrees: next.degrees ?? qualifications.value.degrees,
    credentials: next.credentials ?? qualifications.value.credentials,
  });

  return { qualifications, patchFor };
} // useStaffQualifications()
